import { useEffect, useRef, useState } from 'react';
export function useModal({ onOpenChange, open = false, dismissableOnClickOutside = true }) {
    const [expanded, setExpanded] = useState(false);
    const [shouldRender, setShouldRender] = useState(open);
    const hideTimeoutRef = useRef(null);
    const modalRef = useRef(null);
    useEffect(() => {
        if (open) {
            setShouldRender(true);
            requestAnimationFrame(() => setExpanded(true));
        }
        else {
            setExpanded(false);
            hideTimeoutRef.current = window.setTimeout(() => {
                setShouldRender(false);
            }, 300);
        }
        return () => {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
            }
        };
    }, [open]);
    const handleBackdropClick = (event) => {
        if (!dismissableOnClickOutside)
            return;
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onOpenChange?.(false);
        }
    };
    return { expanded, shouldRender, modalRef, handleBackdropClick };
}
